import React from 'react';
import type { TabNavProps } from './TabNav.types';
import { Box, Item } from './subcomponents';

export const TabNav = (props: TabNavProps) => {
  return <Box {...props} />;
};

// eslint-disable-next-line functional/immutable-data
TabNav.NavItem = Item;
